export default "__VITE_ASSET__851ffbd6__"